export default __webpack_public_path__ + "static/media/emotion.17175fd3.svg";